export const aboutApp = "qgHtcd";
export default {aboutApp};